import React, { ReactElement, useEffect } from 'react';
import { useUserHasRole } from '@/lib/auth/useUserHasRoles';
import { Role } from '@/lib/auth/roles/role.enum';
import { Layout } from 'elmo-elements';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import ContentManagerBaseRoutes, {
  ContentManagerParamTypes,
  ContentManagerTabs,
} from './ContentManagerRoutes';
import MyLibraryRoutes from '../MyLibrary/MyLibraryRoutes';
import CategoriesManagerComponent from './components/CategoriesManager';
import ContentManagerHeader from './components/ContentManagerHeader';
import { useFlags } from 'launchdarkly-react-client-sdk';

const RenderActiveTab = (currentTab: string) => {
  switch (currentTab) {
    case ContentManagerTabs.Categories:
      return <CategoriesManagerComponent />;

    default:
      return <CategoriesManagerComponent />;
  }
};

const ContentManager = (): ReactElement => {
  const { learningElaCourseLibraryAdmin: isElaCourseLibraryEnabled } =
    useFlags();
  const history = useHistory();
  const { tabSelected } = useParams<ContentManagerParamTypes>();
  const isElmoAdmin = useUserHasRole([Role.Admin, Role.Super, Role.Migration]);
  const validTabs = [ContentManagerTabs.Categories];

  useEffect(() => {
    if (validTabs.includes(tabSelected as ContentManagerTabs)) return;

    history.replace(
      generatePath(ContentManagerBaseRoutes.path, {
        tabSelected: ContentManagerTabs.Categories,
      }),
    );
  }, [tabSelected]);

  if (
    (isElmoAdmin !== undefined && !isElmoAdmin) ||
    !isElaCourseLibraryEnabled
  ) {
    history.replace(generatePath(MyLibraryRoutes.path));
  }

  return (
    <>
      <Layout.Header>
        <ContentManagerHeader />
      </Layout.Header>
      <Layout.Content>{RenderActiveTab(tabSelected)}</Layout.Content>
    </>
  );
};
export default ContentManager;
